module.exports = __webpack_public_path__ + "img/pessoa-verde.95fbf612.svg";